import React, { useState } from "react";
import { Box, Drawer, Tabs, Tab, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import UserProfileForm from "./UserProfileForm";
import CloneUserDialog from "./CloneUserDialog";
import UserCustomers from "./UserCustomers";
import UserTerritories from "./UserTerritories";
import WarrantyTab from "./WarrantyTab";

const formatFullName = (u) => `${u.firstName} ${u.lastName}`;

const UserDetailsDrawer = ({
  open,
  onClose,
  activeTab,
  onChangeTab,
  selectedUser,
  allUsers = [],
}) => {
  if (!selectedUser) return null;
  const [cloneOpen, setCloneOpen] = useState(false);

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            height: "70vh",
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
          },
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: 2,
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          {formatFullName(selectedUser)}
        </Typography>

        <IconButton aria-label="Close" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>

      <Tabs
        value={activeTab}
        onChange={(e, v) => onChangeTab && onChangeTab(v)}
        textColor="primary"
        indicatorColor="primary"
        sx={{ borderBottom: "1px solid #e0e0e0" }}
      >
        <Tab label="Profile" />
        <Tab label="Customers" />
        <Tab label="Territory" />
        <Tab label="Warranty" />
      </Tabs>

      <Box sx={{ p: 2, flex: 1 }}>
        {activeTab === 0 && (
          <UserProfileForm
            selectedUser={selectedUser}
            onClone={() => setCloneOpen(true)}
          />
        )}

        {activeTab === 1 && <UserCustomers initialCustomers={[]} />}

        {activeTab === 2 && <UserTerritories initialCodes={[]} />}

        {activeTab === 3 && <WarrantyTab selectedUser={selectedUser} />}
      </Box>

      <CloneUserDialog
        open={cloneOpen}
        onClose={() => setCloneOpen(false)}
        onApply={(payload) => {
          console.log("Apply clone (mobile):", payload);
        }}
        selectedUser={selectedUser}
        allUsers={allUsers}
      />
    </Drawer>
  );
};

export default UserDetailsDrawer;
